// Activate this import to use why-did-you-render
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createRoot } from "react-dom/client";
// Import this last to make sure default styles are overridden
import "./services/i18n";
const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
    <App />
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
